import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import store from 'app/store';

import * as types from 'actions/action_types';
import { scope } from 'actions/Map/map.scope.action';
import { FormattedMessage } from 'react-intl';
// import { API } from '../../../API/manager';
import { pageScope } from '../../../constants/mapConstants';

import pageDataAPI from '../../../API/pageData.api';

import List from '../List/list.container';

const MargueritrutenTours = ({ match }) => {
  const cleanMap = () => {
    store.dispatch({
      type: types.FETCH_TOURS_PUBLIC_FULFILLED,
      payload: [],
    });
    store.dispatch({ type: types.FETCH_PREVIEW_DATA_CLEANE });
  };

  useEffect(() => {
    setTimeout(() => {
      store.dispatch((dispatch) => {
        dispatch({
          type: types.FETCH_TOURS_PUBLIC,
          payload: pageDataAPI.getMargueritrutenTours(),
        });
        dispatch(scope(pageScope.tour));
      });
    }, 100);
    return cleanMap;
  }, []);

  const getLabel = () => (
    <FormattedMessage id="Margueritruten" defaultMessage="Margueritruten" />
  );

  return (
    <Route
      path={`${match.url}/list`}
      render={() => <List label={getLabel()} />}
    />
  );
};

export default MargueritrutenTours;
